import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { addNewSert, changeBookStatus, changeStatus, getBookList, getSerts } from "helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const BookList = () => {
  //meta title
  // document.title = "SCERT BOOK";

  const dispatch = useDispatch();
  const router = useNavigate();

  const [isLoading, setLoading] = useState(false)

  const [list, setList] = useState([])

  const getList = () => {
    setLoading(true)
    getBookList().then((res) => {
      let temp = []
      res?.response?.map((item, ind)=>{
        let obj = {...item}
        obj.class_name1 = item?.class_name?.name1
        obj.medium_name1 = item?.medium_name?.name1
        obj.subject_name1 = item?.subject_name?.name1

        temp.push(obj)
      })
      setList(temp)
      setLoading(false)
    }).catch((err) => {
      console.log('err', err)
      setLoading(false)
    })
  }


  useEffect(() => {
    getList()
  }, []);

  const handleUserClicks = () => {
    router("/form-book")
  };


  const handleStatus = (status) => {
    changeBookStatus(status).then(res => {
      if (res?.success) {
        getList();
        toast.success(res?.message ?? 'Status Updated')
      } else {
        toast.error(res?.message ?? 'somthing went wrong!')
      }
    }).catch(err => {
      console.log('err', err);
    })
  }


  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell, row) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                {cell.row.index + 1}
              </h5>
            </>
          )
        }
      },

      {
        header: 'English Name',
        accessorKey: 'eng_title',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Tamil Name',
        accessorKey: 'tamil_title',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Class Name',
        accessorKey: 'class_name1',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Subject Name',
        accessorKey: 'subject_name1',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Medium Name',
        accessorKey: 'medium_name1',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Status',
        // accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <div>
              {
                cell.row.original?.status ?
                  <button type="button" onClick={() => handleStatus(cell.row.original?.scert_book_id)} className="btn btn-success">Active</button>
                  :
                  <button type="button" onClick={() => handleStatus(cell.row.original?.scert_book_id)} className="btn btn-danger">Deactive</button>
              }
            </div>
          );
        },
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="/form-book"
                state={{data:cellProps.row.original}}
                className="text-success"
                // onClick={() => {
                //   const classData = cellProps.row.original;
                //   handleClassClick(classData);
                // }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="SCERT BOOK" breadcrumbItem="BOOK LIST" />
          <Row>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={list || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search..."
                        isCustomPageSize={true}
                        isAddButton={true}
                        handleUserClick={handleUserClicks}
                        buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                        buttonName="Add Book"
                        tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
            }
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withRouter(BookList);
